// src/pages/Auth/index.jsx
import React, { useState } from 'react';
import { Card, Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import './index.css';

const Auth = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    
    setTimeout(() => {
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('username');
      localStorage.removeItem('avatar');
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('username', values.username);
      message.success('登录成功！');
      window.location.href = '/home';
      
      setLoading(false);
    }, 800);
  };

  return (
    <div 
      className="auth-page"
      style={{
        // 直接在这里添加内联样式
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end', // 右对齐
        padding: '20px 80px 20px 20px', // 右边距80px
        position: 'relative',
        zIndex: 1,
      }}
    >
      {/* 视频背景 */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1,
        }}
      >
        <source src={`${process.env.PUBLIC_URL}/VID_20250214_011637.mp4`} type="video/mp4" />
        您的浏览器不支持视频播放。
      </video>
      
      {/* 半透明遮罩层 */}
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          zIndex: -1,
        }}
      />
      
      <Card 
        className="auth-card"
        title="登录"
        style={{
          width: '100%',
          maxWidth: '420px',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.5)',
          backgroundColor: 'rgba(255, 255, 255, 0.65)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '15px',
          zIndex: 2,
          position: 'relative',
        }}
      >
        <Form
          name="login"
          onFinish={onFinish}
          layout="vertical"
        >
          <Form.Item
            label="账号"
            name="username"
            rules={[{ required: true, message: '请输入账号' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="请输入账号"
              size="large"
            />
          </Form.Item>

          <Form.Item
            label="密码"
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="请输入密码"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
            >
              登录
            </Button>
          </Form.Item>
          
          <div className="auth-footer">
            <div style={{ textAlign: 'center', color: '#666', fontSize: '12px' }}>
              <p>默认账号: admin | 密码: 123456</p>
            </div>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Auth;